import { useDuplicateFlexibleReportRequestMutation } from '@features/flexible-reports';
import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from '@mui/x-data-grid';
import { useCallback } from 'react';

type DuplicateButtonProps = {
  gridActionsCellItemProps: GridActionsCellItemProps;
  campaignId: number;
  flexibleReportRequestId: number;
};

export const DuplicateButton = (props: DuplicateButtonProps) => {
  const { campaignId, flexibleReportRequestId } = props;
  const [duplicateFlexibleReportRequest] =
    useDuplicateFlexibleReportRequestMutation();

  const onClick = useCallback(async () => {
    await duplicateFlexibleReportRequest({
      campaignId,
      flexibleReportRequestId,
    }).unwrap();
  }, [campaignId, flexibleReportRequestId, duplicateFlexibleReportRequest]);

  return (
    <GridActionsCellItem
      {...props.gridActionsCellItemProps}
      onClick={() => void onClick()}
    />
  );
};
